import React, { useEffect, useState } from 'react';

// import ReactDOM from 'react-dom';

import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import firebase from 'firebase';

// import axios from "../axios-paypal";
import Header from '../common/components/Header.js';
import Footer from '../common/components/Footer.js';
import { stripHtml } from '../common/globalMethods.js';
import { URL_ROOT, FIREBASE_CONFIG } from '../common/globalConstants.js';

// const serviceAccount = require('../afterschool-music-firebase-adminsdk-c8aju-f9fde0e58e.json');
// const PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });

const Register = (props) => {

	const {
		allLocations,
		allTextBlocks,
		description,
		history,
		location,
		locationId,
		textBlocks,
		title
	} = props;

	const initialValidationErrors = [
		{ key: "studentFirstName", value: "Student's first name is required"},
		{ key: "studentLastName", value: "Student's last name is required"},
		{ key: "studentDateOfBirth", value: "Student's Date Of Birth is required"},
		{ key: "primaryPhoneNumber", value: "Primary Phone Number is required"},
		{ key: "primaryPhoneNumberType", value: "Primary Phone Number Type is required"},
		{ key: "studentIsMinor", value: "Please indicate whether or not student is under 18 years of age"},
		{ key: "streetAddress1", value: "Street Address is required"},
		{ key: "city", value: "City is required"},
		{ key: "addressState", value: "State is required"},
		{ key: "postalCode", value: "Postal / Zip Code is required"},
		{ key: "country", value: "Country is required"}
	];

	const [pageTextBlocks, setPageTextBlocks] = useState([]);
	const [studentFirstName, setStudentFirstName] = useState('');
	const [studentLastName, setStudentLastName] = useState('');
	const [studentIsMinor, setStudentIsMinor] = useState(null);
	const [studentDateOfBirth, setStudentDateOfBirth] = useState('');
	const [guardianFirstName, setGuardianFirstName] = useState('');
	const [guardianLastName, setGuardianLastName] = useState('');
	const [primaryPhoneNumber, setPrimaryPhoneNumber] = useState('');
	const [primaryPhoneNumberType, setPrimaryPhoneNumberType] = useState('');
	const [secondaryPhoneNumber, setSecondaryPhoneNumber] = useState('');
	const [secondaryPhoneNumberType, setSecondaryPhoneNumberType] = useState('');
	const [email, setEmail] = useState('');
	const [streetAddress1, setStreetAddress1] = useState('');
	const [streetAddress2, setStreetAddress2] = useState('');
	const [city, setCity] = useState('');
	const [addressState, setAddressState] = useState('');
	const [postalCode, setPostalCode] = useState('');
	const [country, setCountry] = useState('United States');

	// eslint-disable-next-line
	const [stateProvinceLabel, setStateProvinceLabel] = useState('State');

	const [hasDesiredTimeslot, setHasDesiredTimeslot] = useState('');
	const [desiredTimeslot, setDesiredTimeslot] = useState('');
	const [medicalConditions, setMedicalConditions] = useState('');
	const [instruments, setInstruments] = useState([]);
	const [comments, setComments] = useState('');

	// eslint-disable-next-line
	const [paymentMethod, setPaymentMethod] = useState('');

	// const [paymentApproved, setPaymentApproved] = useState(false);

	// const [formValidated, setFormValidated] = useState(false);

	const [termsAccepted, setTermsAccepted] = useState(false);
	const [processing, setProcessing] = useState(false);

	// const [registrationFee, setRegistrationFee] = useState(50.00);

	const [validationErrors, setValidationErrors] = useState(initialValidationErrors);
	const [initialEntry, setInitialEntry] = useState(false);
	const [registrationEmail, setRegistrationEmail] = useState('pitmanmusiclessons@gmail.com');

	const instrumentChangeHandler = (e) => {
		if(e.target && e.target.id) {
			let selectedInstruments = [...instruments];

			const currentInstrument = e.target.id.replace('instrument', '');
			const index = selectedInstruments.indexOf(currentInstrument);

			if(e.target.checked && index < 0) {
				selectedInstruments.push(currentInstrument);
			} else if (!e.target.checked && index > -1) {
				selectedInstruments.splice(index, 1);
			}

			setInstruments(selectedInstruments);
		}
	};

	/*
	const paymentTypeChangeHandler = (e) => {
	setPaymentMethod(e.target.value);
	};
	*/

	const studentFirstNameChangeHandler = (e) => {
		setInitialEntry(true);
		setStudentFirstName(e.target.value);
		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'studentfirstname');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "studentFirstName", value: "Student's first name is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const studentLastNameChangeHandler = (e) => {
		setInitialEntry(true);
		setStudentLastName(e.target.value);
		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'studentlastname');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "studentLastName", value: "Student's last name is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const studentIsMinorChangeHandler = (e) => {
		setInitialEntry(true);
		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'studentisminor');

		if(e.target.value && e.target.value.toLowerCase() === "yes") {
			setStudentIsMinor(true);
			currentValidationErrors.push({ key: "guardianFirstName", value: "Guardian's First Name is required"});
			currentValidationErrors.push({ key: "guardianLastName", value: "Guardian's Last Name is required"});
		} else {
			setStudentIsMinor(false);
			currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'guardianfirstname' && x.key.toLowerCase() !== 'guardianlastname');
		}

		setValidationErrors(currentValidationErrors);
	};

	const studentDateOfBirthChangeHandler = (e) => {
		setInitialEntry(true);
		setStudentDateOfBirth(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'studentdateofbirth');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "studentDateOfBirth", value: "Student's Date Of Birth is required"});
		} else {
			const selectedDate = new Date(e.target.value);
			if(selectedDate >= new Date()) {
				currentValidationErrors.push({ key: "studentDateOfBirth", value: "Student's Date Of Birth must be a past date"});
			} else if (selectedDate <= new Date("1/1/1900")) {
				currentValidationErrors.push({ key: "studentDateOfBirth", value: "Student's Date Of Birth must be valid"});
			}
		}
		setValidationErrors(currentValidationErrors);
	};

	const guardianFirstNameChangeHandler = (e) => {
		setInitialEntry(true);
		setGuardianFirstName(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'guardianfirstname');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "guardianFirstName", value: "Guardian's First Name is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const guardianLastNameChangeHandler = (e) => {
		setInitialEntry(true);
		setGuardianLastName(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'guardianlastname');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "guardianLastName", value: "Guardian's Last Name is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const emailChangeHandler = (e) => {
		setInitialEntry(true);
		setEmail(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'email');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "email", value: "Your Email Address is required"});
		} else {

			const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
			if (!pattern.test(e.target.value)) {
				currentValidationErrors.push({ key: "email", value: "Please enter a valid Email Address"});
			}
		}
		setValidationErrors(currentValidationErrors);
	};

	const streetAddress1ChangeHandler = (e) => {
		setInitialEntry(true);
		setStreetAddress1(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'streetaddress1');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "streetAddress1", value: "Street Address is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const streetAddress2ChangeHandler = (e) => {
		setInitialEntry(true);
		setStreetAddress2(e.target.value);
	};

	const cityChangeHandler = (e) => {
		setInitialEntry(true);
		setCity(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'city');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "city", value: "City is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const postalCodeChangeHandler = (e) => {
		setInitialEntry(true);
		setPostalCode(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'postalcode');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "postalCode", value: "Postal / Zip Code is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const countryChangeHandler = (e) => {
		setInitialEntry(true);
		setCountry(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'country');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "country", value: "Country is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const addressStateChangeHandler = (e) => {
		setInitialEntry(true);
		setAddressState(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'addressstate');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "addressState", value: "State is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const primaryPhoneNumberChangeHandler = (e) => {
		setInitialEntry(true);
		setPrimaryPhoneNumber(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'primaryphonenumber');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "primaryPhoneNumber", value: "Primary Phone Number is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const primaryPhoneNumberTypeChangeHandler = (e) => {
		setInitialEntry(true);
		setPrimaryPhoneNumberType(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'primaryphonenumbertype');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "primaryPhoneNumberType", value: "Primary Phone Number Type is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const secondaryPhoneNumberChangeHandler = (e) => {
		setInitialEntry(true);
		setSecondaryPhoneNumber(e.target.value);
	};

	const secondaryPhoneNumberTypeChangeHandler = (e) => {
		setInitialEntry(true);
		setSecondaryPhoneNumberType(e.target.value);
	};

	const hasDesiredTimeslotChangeHandler = (e) => {
		setInitialEntry(true);
		setHasDesiredTimeslot(!hasDesiredTimeslot);
	};

	const desiredTimeslotChangeHandler = (e) => {
		setInitialEntry(true);
		setDesiredTimeslot(e.target.value);
	};

	const medicalConditionsChangeHandler = (e) => {
		setInitialEntry(true);
		setMedicalConditions(e.target.value);
	};

	const commentsChangeHandler = (e) => {
		setInitialEntry(true);
		setComments(e.target.value);
	};

	const termsAcceptedChangeHandler = () => {
		setInitialEntry(true);
		setTermsAccepted(!termsAccepted);
	};

	const onSubmit = () => {
		setProcessing(true);
		const instrumentList = instruments.join(', ');

		const selectedDate = new Date(studentDateOfBirth);
		let options = { month: 'numeric', day: 'numeric', year: 'numeric' };
		const displayDateOfBirth = selectedDate.toLocaleString('en-US', options);

		try {

			// console.warn("studentIsMinor: " + studentIsMinor);
			// console.warn("validationErrors:", validationErrors);

			firebase.firestore().collection('registration').add({
				to: registrationEmail,
				template: {
					name: 'registration',
					data: {
						studentFirstName: stripHtml(studentFirstName),
						studentLastName: stripHtml(studentLastName),
						studentIsMinor: studentIsMinor,
						studentDateOfBirth: displayDateOfBirth,
						guardianFirstName: stripHtml(guardianFirstName),
						guardianLastName: stripHtml(guardianLastName),
						primaryPhoneNumber: stripHtml(primaryPhoneNumber),
						primaryPhoneNumberType: primaryPhoneNumberType,
						secondaryPhoneNumber: stripHtml(secondaryPhoneNumber),
						secondaryPhoneNumberType: secondaryPhoneNumberType,
						emailAddress: stripHtml(email),
						streetAddress1: stripHtml(streetAddress1),
						streetAddress2: stripHtml(streetAddress2),
						city: stripHtml(city),
						state: addressState,
						country: country,
						postalCode: postalCode,
						hasDesiredTimeslot: hasDesiredTimeslot,
						desiredTimeslot: stripHtml(desiredTimeslot),
						medicalConditions: stripHtml(medicalConditions),
						instruments: instrumentList,
						comments: stripHtml(comments)
					}
				}
			}).then(() => {
				// console.warn("Line 303");

				setProcessing(false);
				// eslint-disable-next-line
				if(location.pathname && location.pathname != "") {
					const urlParts = location.pathname.split('/').filter(function(el) { return el.length !== 0 });
					// eslint-disable-next-line
					if(urlParts != null && urlParts.length > 0) {
						history.push('/' + urlParts[0] + '/thankyou?type=register');
					} else {
						history.push(URL_ROOT);
					}
				} else {
					history.push(URL_ROOT);
				}
			}).catch((error) => {
				console.error("Error proccessing registration", error);

				let currentValidationErrors = validationErrors;

				currentValidationErrors.push({ key: "submitError", value: "There was an error submitting the registration.  Please try again later."});
				setValidationErrors(currentValidationErrors);
			});
		} catch(e) {
			console.error("Error submitting form", e);
		}

	};

	/*
	const createOrder = (data, actions) => {
	return actions.order.create({
	purchase_units: [
	{
	amount: {
	value: registrationFee,
	currency_code: 'USD',
	},
	},
	],
	});
	};

	const onPaymentApprove = (data, actions) => {
	setPaymentApproved(true);
	};
	*/

	useEffect(() => {

		/* ToDo FJM (2021-03-13): Code for custom PayPal form
		const axiosOptions = {
		headers: {
		'Accept': 'application/json',
		'Accept-Language': 'en_US'
		},
		auth: {
		username: 'AVlmal8KIAXXG-ly87izIFWgYYe6mCDvOS9Vyw2HpVliiAJsboxYQ0VM4cCxsPxu6UYIXU-9Bsmh17Zt',
		password: 'EBg6S9osZKlBHtFVk-jg3_Neo-fc-X4MFTXAXGDo_lTEHgwYjDmuWvH7vsj-4lthld5LKmSzosYmK_3F'
		}
		};

		axios.post(
		'/oauth2/token',
		'grant_type=client_credentials',
		axiosOptions
		)
		.then(response => {
		const responseData = response.data;
		if(responseData && responseData.access_token) {
		console.warn("access_token", responseData.access_token);
		const url = 'https://www.paypal.com/sdk/js?components=buttons,hosted-fields&client-id=' + 'AVlmal8KIAXXG-ly87izIFWgYYe6mCDvOS9Vyw2HpVliiAJsboxYQ0VM4cCxsPxu6UYIXU-9Bsmh17Zt';
		const script = document.createElement('script');
		script.src = url;
		script.async = false;
		script.onload = () => loadPayPalButtons();
		script.setAttribute('data-client-token', responseData.access_token);
		document.body.appendChild(script);
		} else {
		console.warn("could not parse responseData", responseData);
		}
		})
		.catch(error => {
		console.warn("Error", error);
		});
		*/

		/*
		const script = document.createElement('script');
		script.src = 'https://www.paypal.com/sdk/js?client-id=AVlmal8KIAXXG-ly87izIFWgYYe6mCDvOS9Vyw2HpVliiAJsboxYQ0VM4cCxsPxu6UYIXU-9Bsmh17Zt';
		script.async = false;
		script.onload = () => loadPayPalButtons();
		document.body.appendChild(script);
		*/

		if (!firebase.apps.length) {
			firebase.initializeApp(FIREBASE_CONFIG);
		} else {
			firebase.app();
		}

		if(allTextBlocks && allTextBlocks.length > 0) {
			if(textBlocks) {
				const currentTextBlocks = [];
				let matchingTextBlock = [];
				if(!Array.isArray(textBlocks)) {
					// eslint-disable-next-line
					matchingTextBlock = allTextBlocks.filter(x => x.id == textBlocks.TextBlockId);
					if(matchingTextBlock && matchingTextBlock.length === 1) {
						currentTextBlocks.push(matchingTextBlock[0]);
					}
				} else {
					for(let i = 0; i < textBlocks.length; i++) {
						// eslint-disable-next-line
						matchingTextBlock = allTextBlocks.filter(x => x.id == textBlocks[i].TextBlockId);
						if(matchingTextBlock && matchingTextBlock.length === 1) {
							currentTextBlocks.push(matchingTextBlock[0]);
						}
					}
				}

				setPageTextBlocks(currentTextBlocks);
			}
		} else {
			history.push(URL_ROOT);
		}

		if(allLocations && allLocations.length > 0) {
			// eslint-disable-next-line
			const matchingLocation = allLocations.filter(x => x.id == locationId);
			if(matchingLocation && matchingLocation.length === 1) {
				setRegistrationEmail(matchingLocation[0].RegistrationEmail);
			}
		} else {
			history.push(URL_ROOT);
		}
		// eslint-disable-next-line
	}, []);

	/* ToDo FJM (2021-03-13): Advanced usage of PayPal fields
	const loadPayPalButtons = () => {

	// Displays PayPal buttons
	window.paypal.Buttons({
	onError: function (err) {
	console.warn('buttons onError', err);
	},
	onInit: function(data, actions)  {
	console.warn('buttons oninit data', data);
	console.warn('buttons oninit actions', actions);
	},
	onClick: function(data, actions)  {
	console.warn('buttons onClick data', data);
	console.warn('buttons onClick actions', actions);
	},
	createOrder: function(data, actions) {
	console.warn('Buttons data', data);
	console.warn('Buttons actions', actions);
	return actions.order.create({
	purchase_units: [{
	amount: {
	value: registrationFee,
	currency_code: 'USD',
	}
	}]
	});
	},
	onApprove: function(data, actions) {
	return actions.order.capture().then(function(details) {
	setPaymentApproved(true);
	});
	}
	}).render("#paypal-button-container");

	// If this returns false or the card fields aren't visible, see Step #1.
	if (window.paypal.HostedFields.isEligible()) {

	// Renders card fields
	window.paypal.HostedFields.render({
	// Call your server to set up the transaction
	createOrder: function () {
	console.warn('createOrder');
	},
	styles: {
	'.valid': {
	'color': 'green'
	},
	'.invalid': {
	'color': 'red'
	}
	},
	fields: {
	number: {
	selector: "#card-number",
	placeholder: "4111 1111 1111 1111"
	},
	cvv: {
	selector: "#cvv",
	placeholder: "123"
	},
	expirationDate: {
	selector: "#expiration-date",
	placeholder: "MM/YY"
	}
	}
	}).then(function (cardFields) {
	document.querySelector("#card-form").addEventListener('submit', (event) => {
	event.preventDefault();
	cardFields.submit({
	// Cardholder's first and last name
	cardholderName: document.getElementById('card-holder-name').value,
	// Billing Address
	billingAddress: {
	// Street address, line 1
	streetAddress: document.getElementById('card-billing-address-street').value,
	// Street address, line 2 (Ex: Unit, Apartment, etc.)
	extendedAddress: document.getElementById('card-billing-address-unit').value,
	// State
	region: document.getElementById('card-billing-address-state').value,
	// City
	locality: document.getElementById('card-billing-address-city').value,
	// Postal Code
	postalCode: document.getElementById('card-billing-address-zip').value,
	// Country Code
	countryCodeAlpha2: document.getElementById('card-billing-address-country').value
	}
	}).then(function () {
	// Payment was successful! Show a notification or redirect to another page.
	// window.location.replace('http://www.somesite.com/review');
	setPaymentApproved(true);
	}).catch(function (err) {
	setValidationErrors(JSON.stringify(err));
	// alert('Payment could not be captured! ' + JSON.stringify(err))
	});
	});
	});
	} else {
	// Hides card fields if the merchant isn't eligible
	// document.querySelector("#card-form").style = 'display: none';
	}
	};
	*/


	/*
	<script src="https://www.paypal.com/sdk/js?components=buttons,hosted-fields&client-id=<YOUR-CLIENT-ID>" data-client-token="<YOUR-CLIENT-TOKEN>"></script>


	const loadPayPalButtons = () => {
	window.paypal.Buttons({
	createOrder: function(data, actions) {
	return actions.order.create({
	purchase_units: [{
	amount: {
	currency_code: 'USD',
	value: registrationFee,
	}
	}]
	});
	},
	onApprove: function(data, actions) {
	return actions.order.capture().then(function(details) {
	setPaymentApproved(true);
	});
	}
	}).render('#paypal-button-container');
	};
	*/

	return (
		<React.Fragment>
			<MetaTags>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:title" content={title} />
			</MetaTags>
			<Header locationId={locationId} />
			<main>
				<div className='content'>
					<div className='pageContent'>
						<h1>Register for Lessons</h1>
						{pageTextBlocks.map(pageTextBlock => {
							if(pageTextBlock.IsHtml) {
								return <div key={pageTextBlock.id} className='bodyHtml' dangerouslySetInnerHTML={{__html: pageTextBlock.BodyText}} />;
							} else {
								return <p key={pageTextBlock.id} className='bodyText'>{pageTextBlock.BodyText}</p>;
								}
							})}
							<div className='formSection'>
								<h3>Student's Name</h3>
								<input type='text' value={studentFirstName} maxLength='100' placeholder='First Name' onChange={studentFirstNameChangeHandler} />
								<input type='text' value={studentLastName} maxLength='100' placeholder='Last Name' onChange={studentLastNameChangeHandler} />
							</div>
							<div className='formField'>
								<span>Is student under 18 years of age?</span>
								&nbsp;
								<input id='studentIsMinor_Yes' type='radio' value='Yes' checked={studentIsMinor === true} onChange={studentIsMinorChangeHandler} className='inlineRadioButton' />
								<label htmlFor='studentIsMinor_Yes'>Yes</label>
								&nbsp;
								<input id='studentIsMinor_No' type='radio' value='No' checked={studentIsMinor === false} onChange={studentIsMinorChangeHandler} className='inlineRadioButton'/>
								<label htmlFor='studentIsMinor_No'>No</label>
							</div>
							{studentIsMinor && (
								<div className='formSection'>
									<h3>Guardian's Name</h3>
									<input type='text' value={guardianFirstName} maxLength='100' placeholder='Guardian&apos;s First Name' onChange={guardianFirstNameChangeHandler} />
									<input type='text' value={guardianLastName} maxLength='100' placeholder='Guardian&apos;s Last Name' onChange={guardianLastNameChangeHandler} />
								</div>
							)}

							<div className='formSection'>
								<h3>Address</h3>
								<input type='text' value={streetAddress1} maxLength='100' placeholder='Street Address Line 1' onChange={streetAddress1ChangeHandler} />
								<input type='text' value={streetAddress2} maxLength='100' placeholder='Street Address Line 2' onChange={streetAddress2ChangeHandler} />
								<input type='text' value={city} placeholder='City' onChange={cityChangeHandler} />
								<input type='text' value={postalCode} placeholder='Postal / Zip Code' onChange={postalCodeChangeHandler} />
								<select value={country} onChange={countryChangeHandler}>
									<option value=''>Country</option>
									<option value='US'>United States</option>
								</select>
								<select value={addressState} onChange={addressStateChangeHandler}>
									<option value=''>{stateProvinceLabel}</option>
									<option value='AL'>Alabama</option>
									<option value='AK'>Alaska</option>
									<option value='AZ'>Arizona</option>
									<option value='AR'>Arkansas</option>
									<option value='CA'>California</option>
									<option value='CO'>Colorado</option>
									<option value='CT'>Connecticut</option>
									<option value='DE'>Delaware</option>
									<option value='FL'>Florida</option>
									<option value='GA'>Georgia</option>
									<option value='HI'>Hawaii</option>
									<option value='ID'>Idaho</option>
									<option value='IL'>Illinois</option>
									<option value='IN'>Indiana</option>
									<option value='IA'>Iowa	Des</option>
									<option value='KS'>Kansas</option>
									<option value='KY'>Kentucky</option>
									<option value='LA'>Louisiana</option>
									<option value='ME'>Maine</option>
									<option value='MD'>Maryland</option>
									<option value='MA'>Massachusetts</option>
									<option value='MI'>Michigan</option>
									<option value='MN'>Minnesota</option>
									<option value='MS'>Mississippi</option>
									<option value='MO'>Missouri</option>
									<option value='MT'>Montana</option>
									<option value='NE'>Nebraska</option>
									<option value='NV'>Nevada</option>
									<option value='NH'>New Hampshire</option>
									<option value='NJ'>New Jersey</option>
									<option value='NM'>New Mexico</option>
									<option value='NY'>New York</option>
									<option value='NC'>North Carolina</option>
									<option value='ND'>North Dakota</option>
									<option value='OH'>Ohio</option>
									<option value='OK'>Oklahoma</option>
									<option value='OR'>Oregon</option>
									<option value='PA'>Pennsylvania</option>
									<option value='RI'>Rhode Island</option>
									<option value='SC'>South Carolina</option>
									<option value='SD'>South Dakota</option>
									<option value='TN'>Tennessee</option>
									<option value='TX'>Texas</option>
									<option value='UT'>Utah</option>
									<option value='VT'>Vermont</option>
									<option value='VA'>Virginia</option>
									<option value='WA'>Washington</option>
									<option value='WV'>West Virginia</option>
									<option value='WI'>Wisconsin</option>
									<option value='WY'>Wyoming</option>
								</select>
							</div>

							<div className='formSection'>
								<h3>Best Phone Number to Contact</h3>
								<input className='phoneNumber' type='text' maxLength='20' value={primaryPhoneNumber} placeholder='Phone Number' onChange={primaryPhoneNumberChangeHandler} />
								<select className='phoneNumberType' value={primaryPhoneNumberType} onChange={primaryPhoneNumberTypeChangeHandler}>
									<option value=''>Type</option>
									<option value='Home'>Home</option>
									<option value='Work'>Work</option>
									<option value='Cell'>Cell</option>
									<option value='Other'>Other</option>
								</select>
							</div>

							<div className='formSection'>
								<h3>Alternate Phone Number</h3>
								<input className='phoneNumber' type='text' maxLength='20' value={secondaryPhoneNumber} placeholder='Phone Number' onChange={secondaryPhoneNumberChangeHandler} />
								<select className='phoneNumberType' value={secondaryPhoneNumberType} onChange={secondaryPhoneNumberTypeChangeHandler}>
									<option value=''>Type</option>
									<option value='Home'>Home</option>
									<option value='Work'>Work</option>
									<option value='Cell'>Cell</option>
									<option value='Other'>Other</option>
								</select>
							</div>

							<div className='formSection'>
								<h3>Email Address</h3>
								<input type='text' value={email} onChange={emailChangeHandler} />
							</div>

							<div className='formSection'>
								<h3>Student&apos;s Date of Birth (including birth year)</h3>
								<input type='date' value={studentDateOfBirth} onChange={studentDateOfBirthChangeHandler} />
							</div>

							<div className='formSection'>
								<h3>Have you chosen your desired teacher and lesson time slot(s)?</h3>
								<input type='radio' name='chosenTimeslot' checked={hasDesiredTimeslot} onChange={hasDesiredTimeslotChangeHandler} id='hasChosenTimeslot'/>
								<label htmlFor='hasChosenTimeslot'>Yes</label>

								<input type='radio' name='chosenTimeslot' checked={!hasDesiredTimeslot} id='noChosenTimeslot' onChange={hasDesiredTimeslotChangeHandler} className='inlineRadioButton' />
								<label htmlFor='noChosenTimeslot'>No</label>

								{hasDesiredTimeslot && (
									<React.Fragment>
										<h3>What works best for you?</h3>
										<textarea type='text' rows='4' maxLength='255' value={desiredTimeslot} placeholder='Desired Timeslot' onChange={desiredTimeslotChangeHandler}></textarea>
									</React.Fragment>
								)}
							</div>

							<div className='formSection'>
								<h3>Instruments</h3>
								<div id='instrumentList'>
									<div className='column'>
										<input type='checkbox' id='instrumentBass' checked={instruments.includes('Bass')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentBass'>Bass</label>
										<br />

										<input type='checkbox' id='instrumentClarinet' checked={instruments.includes('Clarinet')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentClarinet'>Clarinet</label>
										<br />

										<input type='checkbox' id='instrumentFlute' checked={instruments.includes('Flute')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentFlute'>Flute</label>
										<br />

										<input type='checkbox' id='instrumentGuitar' checked={instruments.includes('Guitar')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentGuitar'>Guitar</label>
										<br />

										<input type='checkbox' id='instrumentPiano' checked={instruments.includes('Piano')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentPiano'>Piano</label>
									</div>
									<div className='column'>
										<input type='checkbox' id='instrumentSaxophone' checked={instruments.includes('Saxophone')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentSaxophone'>Saxophone</label>
										<br />

										<input type='checkbox' id='instrumentTrumpet' checked={instruments.includes('Trumpet')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentTrumpet'>Trumpet</label>
										<br />

										<input type='checkbox' id='instrumentUkulele' checked={instruments.includes('Ukulele')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentUkulele'>Ukulele</label>
										<br />

										<input type='checkbox' id='instrumentVoice' checked={instruments.includes('Voice')}  onChange={(e) => instrumentChangeHandler(e)}/>
										<label htmlFor='instrumentVoice'>Voice</label>
									</div>
								</div>
							</div>

							<div className='formSection'>
								<h3>Allergies or medical conditions we should be aware of</h3>
								<textarea value={medicalConditions} rows='4' maxLength='255' onChange={medicalConditionsChangeHandler}></textarea>
							</div>

							<div className='formSection'>
								<h3>Questions or comments</h3>
								<textarea value={comments}  rows='4' maxLength='255' onChange={commentsChangeHandler}></textarea>
							</div>
							<div className='formField'>
								<input type='checkbox' id="termsAccepted" checked={termsAccepted} onChange={termsAcceptedChangeHandler}/>
								&nbsp;
								<label htmlFor="termsAccepted">I have read and accepted the <Link to='/pitman/privacypolicy' target='_blank' rel='noreferrer'>Privacy Policy</Link>.</label>
							</div>

							{initialEntry && !termsAccepted && <span className='validationErrors'>You must accept the Privacy Policy before creating an account.</span>}
							<div className='formSection submitButtonContainer'>
								{initialEntry && validationErrors && validationErrors.length > 0 && <ul className='validationErrors'>{validationErrors.map((validationError, index) => (
									<li key={index}>{validationError.value}</li>
								))}</ul>}
								<button className='submit' onClick={onSubmit} disabled={validationErrors.length > 0 || !termsAccepted || processing}>Register</button>
							</div>
						</div>
					</div>
				</main>
				<Footer locationId={locationId} />
			</React.Fragment>
		);
	};

	const mapStateToProps = state => {
		return {
			allTextBlocks: state.application.textBlocks,
			allLocations: state.application.locations
		};
	};

	export default withRouter(connect(mapStateToProps, null)(Register));
